'use strict';

require('../../style/index.css');

require('./index.css');

require('../../checkbox/style/css');

require('../../button/style/css');

require('../../input/style/css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/transfer/style/css.js
// module id = Hwqs
// module chunks = 0